/** The marketing site (apps/marketing): legal pages, help centre, docs. */
export const MARKETING_URL =
  (import.meta.env.VITE_MARKETING_URL as string | undefined) ?? 'http://localhost:5185';

/** A page on the marketing site, e.g. marketingUrl('/privacy'). */
export function marketingUrl(path: string) {
  return `${MARKETING_URL.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
}

export const LEGAL_LINKS = {
  privacy: '/privacy',
  terms: '/terms',
  help: '/help',
} as const;
